{
    "ROOT": {
        "description": "Programmierer",
        "color": "#FF0000"
    },
    "ADMIN": {
        "description": "Administrator",
        "color": "#FF6666"
    },
    "DWC": {
        "description": "Dr. Wolf Communications",
        "color": "#82b895",
        "css": "dwc"
    },
    "TCF": {
        "description": "The Campaign Factory",
        "color": "#00ff00",
        "css": "tcf"
    },
    "VELTI": {
        "description": "Velti",
        "color": "#2682e0",
        "css": "velti"
    },
    "AI": {
        "description": "AI-Verantwortlicher",
        "color": "#00ff33"
    },
    "USERS": {
        "description": "Benutzer-Manager",
        "color": "#336699"
    },
    "BILLING": {
        "description": "Rechnungsstellung",
        "color": "#ffff00"
    }
}
